<template>  
  <div class="faq">
    <accordion-group class="faq__category" v-for="(faqsObj, index) in faqsList" :key="index">
      <p class="faq__title h5">{{faqsObj.category}}</p>
      <accordion v-for="(faq, subindex) in faqsObj.values" :key="subindex" :heading="faq.question" activeIcon="minus" :auto-close="false" theme="faq">
        <div class="faq__answer client-generated" v-html="faq.answer"></div>
      </accordion>
    </accordion-group>
  </div>
</template>

<script>
import AccordionGroup from '@/scripts/components/basic/AccordionGroup.vue'
import Accordion from '@/scripts/components/basic/Accordion.vue'

export default {
  name: 'FAQs',
  components: {
    AccordionGroup,
    Accordion
  },
  props: {
    faqsList: {
      type: Array,
      default: () => ([{}])
    }
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.faq {
  margin-bottom: 0;

  @include tablet-up {
    padding-top: 16px;
  }

  &__category {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  &__title {
    margin-bottom: 16px;
  }

  &__answer {
    margin-bottom: 0;
  }
}
</style>

<style lang="scss">
  .faq__answer {
    ul {
      margin: 0;
      padding-left: 20px;

      @include tablet-up {
        padding-left: 27px;
      }

      li {
        margin-bottom: 8px;

        &:last-child {
          margin-bottom: 0;
        }
      }
    }

    p {
      &:not(:last-child) {
        margin-bottom: 16px;
      }
    }

    tbody {
      border-top-color: $color-faq-table-border;
    }
  }
</style>
